
/*
* Project: LegalPlace assistant
* File: src/logic/global_getter.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/

import { store } from '../globals';
import lpApp from '../app/lp_app';
// get the option
const optionDefaults = {};

function getOptionDefaults() {
  if (lpApp && lpApp.references.options) {
    Object.keys(lpApp.references.options).map((idx) => {
      const now = lpApp.references.options[idx];
      optionDefaults[now.meta.default] = true;
    });
  }
  window.default_opts = optionDefaults;
}
// logger with color

function getOptionPass(id) {
  if (Object.keys(optionDefaults).length === 0) getOptionDefaults();
  let cId = id;
  if (typeof id === 'string') {
    const _ = id.split('_');
    [cId] = _;
  }
  // if(typeof id == 'string')debugger;
  if (typeof lpApp.references.getOption(cId) === 'undefined') return false;
  const optType = lpApp.references.getOption(cId).meta.type;

  let theOptions = false;
  // the default phase

  if (optType === 'radio') {
    // default pass

    if (optionDefaults[id]) {
      theOptions = optionDefaults[id];
    }

    // ovc pass
    if (store.getState().loadedOvc.oF && store.getState().loadedOvc.oF[id]) {
      theOptions = store.getState().loadedOvc.oF[id];
      // check the string, or number
    } else theOptions = false;
  } else
  if (optType === 'checkbox') {
    if (store.getState().loadedOvc.cF && store.getState().loadedOvc.cF[id]) {
      theOptions = store.getState().loadedOvc.cF[id];
      // check the string, or number
    } else theOptions = false;
  } else if (optType === 'static' || optType === 'brut-text') {
    // console.log("detected text")
    theOptions = 'NONE';
  } else if (optType === 'hidden') {
    theOptions = 'NONE';
  }

  // if(typeof lpGetOptionById(id) != 'undefined'){
  //     theOptions = lpGetOptionById(id).value;
  //     // console.log("%c" + id + " : " + theOptions, "color: pink");
  // }
  return theOptions;
}


function getVariablePass(id) {
  let theVariable = '';
  let cId = id;
  if (typeof id === 'string') {
    [cId] = id.split('_');
  }
  if (!lpApp.references.getVariable(cId)) return '';
  if (store.getState().loadedOvc.vF && store.getState().loadedOvc.vF[id]) {
    theVariable = store.getState().loadedOvc.vF[id];
  }

  return theVariable;
}


function lpIdGetPure(idx) {
  if (typeof idx === 'string') return parseInt(idx.split('_')[0], 10);
  return idx;
}

function lpIdGetCopy(idx) {
  if (typeof idx === 'string') {
    const _ = idx.split('_');
    if (_.length > 1) return _[1];
    return -2;
  }
  return -2;
}

window.update_it = getOptionDefaults;
getOptionDefaults();

export {
  getOptionPass,
  getVariablePass,
  lpIdGetPure,
  lpIdGetCopy,
};



// WEBPACK FOOTER //
// ./src/logic/global_getter.js